<div class="d-flex h-100 bg-primary text-white overflow-hidden">
    <div class="m-auto">
        <img class="w-100" src="../../../assets/img/404.svg" alt="404 Error Image">
        <div class="text-center">
            <h3>La pagina que intentas solicitar no esta en el servidor</h3>
            <a href="/" class="btn btn-dark w-25 btn-lg mt-3">Regresar al inicio</a>
        </div>
    </div>
</div>